import React, { useContext, useEffect } from "react";
import NavigationContext from "../../context/navigation/NavigationContext";
// import ellipse from './loading-icon-4.gif'

const Preloader = (props) => {
  const navigationContext = useContext(NavigationContext);
  const { setAutorunBanner } = navigationContext;

  useEffect(() => {
    setAutorunBanner(false);
    return () => {
      setAutorunBanner(true);
    };
    //eslint-disable-next-line
  }, []);

  return (
    <div className="overlay">
      <h1 role="alert" style={{ color: "transparent", height: "1px" }}>
        Please wait , Your request is being processed
      </h1>
      <div className="overlay-content preloader">
        {/* <img src={ellipse} /> */}
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
  );
};

export default Preloader;
